'use strict';

angular.module('theme').service('CartService', function ($rootScope, $q, $http, $cookies, ArticleService, CUSTOMER) {

	var service = this;

	this.empty = function () {
		return $cookies.get('cart') === undefined;
	};

	this.giftCardEmpty = function () {
		return $cookies.get('giftcard') === undefined;
	};

	this.showCart = function () {
		// If there is a logged in user, and it has access to my page, we dont' show the cart
		if ($rootScope.customer && $rootScope.customer.hasAccessToMyPage) {
			return false;
		}
		// Else we show the cart if it's not empty
		return !service.empty();
	};

	this.clear = function () {
		$cookies.remove('cart', {
			path: '/'
		});
		$cookies.remove('campaign-code', {
			path: '/'
		});
		$cookies.remove('cart-payMethod', {
			path: '/'
		});
		$cookies.remove('cart-products', {
			path: '/'
		});
		$cookies.remove('cart-delivery', {
			path: '/'
		});
		console.log('cart clear');
	};

	this.clearGiftCard = function() {
		$cookies.remove('giftcard', {
			path: '/'
		});
	};

	this.add = function (article, servings) {

		var data = {
			// Either it's a article from /articles or it's a response from /cart
			id: article.nextArticleId || article.id,
			type: article.type,
			number: servings
		};

		return $http({
			url: '/backapi/cart',
			method: 'POST',
			data: {
				article: data
			}
		}).then(function (response) {
			console.log('add to cart', response.data);
			service._setCookie(response.data);

			return response.data;
		});
	};

	this.save = function (cart) {
		var data = {};

		if(!cart.article) {
			data.article = cart;
		} else {
			// Discard data that isn't needed;
			delete cart['customer'];
			delete cart['total'];
			delete cart['status'];
			delete cart['message'];
			delete cart.article['price'];
			delete cart.discountcode['img'];
			delete cart.discountcode['selection1'];
			delete cart.discountcode['selection2'];
			delete cart.discountcode['selection3'];
			delete cart.discountcode['amount'];
			delete cart.discountcode['status'];
			delete cart.discountcode['message'];
			delete cart.giftvoucher['amount'];
			delete cart.giftvoucher['message'];
			data = cart;
		}

		// Use campaign code if user visited a campaign page
		var campaignCode = $cookies.get('campaign-code');
		if(campaignCode && cart.discountcode.id === '') {
			data.discountcode = {
				id: campaignCode
			};
			console.log('setting campaign code from cookie', campaignCode);
		}

		// Use test week if cookie exist
		var testCode = $cookies.get('test-week');
		if(testCode) {
			data.test = {
				id: 'test-page'
			};
			console.log('setting cart to have test week');
		}

		return $http({
			url: '/backapi/cart',
			method: 'POST',
			data: data
		}).then(function (response) {
			console.log('save cart', response.data);
			service._setCookie(response.data);
			return response.data;
		});
	};

	this.saveGiftCard = function (cart) {
		var data = cart;

		return $http({
			url: '/backapi/cart',
			method: 'POST',
			data: data
		}).then(function (response) {
			console.log('save giftcard', response.data);
			service._setGiftCardCookie(response.data);
			return response.data;
		});
	};

	this.saveCartDelivery = function (delivery) {
		var expires = new Date();
		expires.setDate(expires.getDate() + 1);

		$cookies.putObject('cart-delivery', delivery, {
			path: '/',
			expires: expires
		});
	};

	this.getCartDelivery = function() {
		return $cookies.getObject('cart-delivery');
	};

	this.clearCartDelivery = function() {
		$cookies.remove('cart-delivery', {
			path: '/'
		});
	};

	/**
	 * Gets the saved cart from the server
	 */
	this.get = function () {
		var cart = service._getCookie();
		if (!cart) {
			return $q.reject('No cart available');
		}

		// If we are not logged in we get the cookie and update it with /cart and return the value from there
		if (!CUSTOMER) {
			return service.save(cart);
		}

		// If the customer has logged in or signed up, there cart will be null on the server,
		// therefor we need to first resave the latest cart we have in the browser
		if ($cookies.get('reset-cart')) {
			$cookies.remove('reset-cart');
			console.log('restore cart after login', cart);
			return service.save(cart);
		}

		return $http({
			url: '/backapi/cart',
			method: 'GET',
			cache: false
		}).then(function (response) {
			console.log('retrieved cart', response.data);
			service._setCookie(response.data);
			return response.data;
		}, function (response) {
			// If there is no saved cart we remove the cookie
			if (response.status === 400) {
				service.clear();
			}

			return $q.reject(response);
		});
	};

	this.getGiftCard = function () {
		var cart = service._getGiftCardCookie();
		if (!cart) {
			return $q.reject('No cart available');
		}

		// If we are not logged in we get the cookie and update it with /cart and return the value from there
		if (!CUSTOMER) {
			return service.saveGiftCard(cart);
		}

		// If the customer has logged in or signed up, there cart will be null on the server,
		// therefor we need to first resave the latest cart we have in the browser
		if ($cookies.get('reset-giftcard')) {
			$cookies.remove('reset-giftcard');
			console.log('restore cart after login', cart);
			return service.saveGiftCard(cart);
		}

		return $http({
			url: '/backapi/cart',
			method: 'GET',
			cache: false
		}).then(function (response) {
			console.log('retrieved cart', response.data);
			service._setGiftCardCookie(response.data);
			return response.data;
		}, function (response) {
			// If there is no saved cart we remove the cookie
			if (response.status === 400) {
				$cookies.remove('giftcard', {
					path: '/'
				});
			}

			return $q.reject(response);
		});
	};

	this._getCookie = function () {
		return $cookies.getObject('cart');
	};

	this._setCookie = function (cart) {
		var expires = new Date();
		expires.setDate(expires.getDate() + 365);

		$cookies.putObject('cart', cart, {
			path: '/',
			expires: expires
		});

		return cart;
	};

	this._getGiftCardCookie = function () {
		return $cookies.getObject('giftcard');
	};

	this._setGiftCardCookie = function (cart) {
		var expires = new Date();
		expires.setDate(expires.getDate() + 365);

		$cookies.putObject('giftcard', cart, {
			path: '/',
			expires: expires
		});

		return cart;
	};

	this.getTerms = function () {
		return $http({
			url: '/mypage/terms/?content=true'
		}).then(function (response) {
			return response;
		});
	};

	this.getGiftCardTerms = function () {
		return $http({
			url: '/giftcard-terms/?content=true'
		}).then(function (response) {
			return response;
		});
	};

	this.setPayMethod = function (payMethod) {
		var expires = new Date();
		expires.setDate(expires.getDate() + 365);

		$cookies.putObject('cart-payMethod', payMethod, {
			path: '/',
			expires: expires
		});
	};

	this.getPayMethod = function () {
		if (!$cookies.getObject('cart-payMethod')) {
			this.setPayMethod('card');
			return 'card';
		} 
		
		return $cookies.getObject('cart-payMethod');
	};

	// Expose clear as a window function for easier debugging
	window.clearCart = function () {
		service.clear();
	};

});
